<script>
import dailyReportControlRules from "@/mixins/dailyReportControlRules";
import VendorsName from '@/views/pages/daily_reports/components/vendors_name.vue';
import VendorsAddress from '@/views/pages/daily_reports/components/vendors_address.vue';
import VendorSitesName from '@/views/pages/daily_reports/components/vendor_sites_name.vue';
import VendorSitesAddress from '@/views/pages/daily_reports/components/vendor_sites_address.vue';
export default {
  name: "daily_report_info",
  mixins: [dailyReportControlRules],
  components: {
    VendorsName,
    VendorsAddress,
    VendorSitesName,
    VendorSitesAddress,
  },
  props: {
    dailyReport: {
      type: Object,
      required: true,
    },
    vendorSite: {
      type: Object|null,
    },
    index: {
      type: Number|String,
      default: 0,
    },
    controlRules: {
      type: Object|null,
    },
  },
  data() {
    return {
    }
  },
  methods: {
  },
  computed: {
    isTransportCompleteOptions() {
      return [{text: '未完了', value: 0}, {text: '完了', value: 1}]
    },
    startEndTimeSchedule() {
      if (!this.dailyReport.schedule) {
        return '';
      }
      const startTimeFormatted = this.$moment(this.dailyReport.schedule.start_datetime).format('YYYY/MM/DD HH:mm'); 
      const endTimeFormatted = this.$moment(this.dailyReport.schedule.end_datetime).format('YYYY/MM/DD HH:mm');
      return `${startTimeFormatted} ～ ${endTimeFormatted}`;
    },
    caseDischarger() {
      return this.dailyReport?.work_order_json?.case?.discharger?.name;
    },
    caseDischargerAddress() {
      return [
        this.$helpers.formatZipCode(this.dailyReport?.work_order_json?.case?.discharger?.zip),
        this.dailyReport?.work_order_json?.case?.discharger?.address_1,
        this.dailyReport?.work_order_json?.case?.discharger?.address_2,
        this.dailyReport?.work_order_json?.case?.discharger?.address_3,
        this.dailyReport?.work_order_json?.case?.discharger?.address_4,
      ].filter(x => !!x).join('');
    },
    caseDischargerSite() {
      return this.dailyReport?.work_order_json?.case?.discharger_site?.name;
    },
    caseDischargerSiteAddress() {
      return [
        this.$helpers.formatZipCode(this.dailyReport?.work_order_json?.case?.discharger_site?.zip),
        this.dailyReport?.work_order_json?.case?.discharger_site?.address_1,
        this.dailyReport?.work_order_json?.case?.discharger_site?.address_2,
        this.dailyReport?.work_order_json?.case?.discharger_site?.address_3,
        this.dailyReport?.work_order_json?.case?.discharger_site?.address_4,
      ].filter(x => !!x).join('');
    },
    caseId() {
      return this.dailyReport?.work_order_json?.case_id;
    },
    workOrderId() {
      return this.dailyReport?.work_order_json?.id;
    },
    treatmentAcceptedOptions() {
      if (this.dailyReport?.work_order_json?.zz_work_order_type_id.toString() === this.$constant.work_order_type.disposal) {
        return [{text: '搬入未完了', value: 0}, {text: '搬入完了', value: 1}];
      }
      return [{text: '未完了', value: 0}, {text: '完了', value: 1}];
    },
    treatmentCompletedOptions() {
      if (this.dailyReport?.work_order_json?.zz_work_order_type_id.toString() === this.$constant.work_order_type.disposal) {
        return [{text: '処分未完了', value: 0}, {text: '処分完了', value: 1}];
      }
      return [{text: '未完了', value: 0}, {text: '完了', value: 1}];
    },
    needDisplayVendorInfo() {
      if (this.dailyReport?.work_order_json?.zz_work_order_type_id.toString() === this.$constant.work_order_type.work
          || this.dailyReport?.work_order_json?.zz_work_order_type_id.toString() === this.$constant.work_order_type.others) {
        // 作業・その他では処分事業者・事業場欄は不要
        return false;
      }
      return true;
    },
    updatedOrCreatedBy(){
      if(this.dailyReport.user_updated_by){
        return this.dailyReport.user_updated_by.user_name;
      }else{
        return this.dailyReport?.user_created_by?.user_name;
      }
    },
    assignedStaffs(){
      if(this.dailyReport.schedule?.assigned_staffs_by_schedule){
        return this.dailyReport.schedule.assigned_staffs_by_schedule.map(item => item.user_name).join(',')
      }
      return '';
    }
  }
}
</script>

<template>
  <b-card class="mb-2">
    <b-row>
      <b-col cols="5" class="d-flex">
        <div class="d-flex me-5" v-if="index">
          <div class="me-3"><b>No</b></div>
          <div>{{index}}</div>
        </div>
        <div class="d-flex gap-3">
          <div class="me-3"><b>受付番号</b></div>
          <div>{{ dailyReport.schedule_id }}</div>
        </div>
      </b-col>
      <b-col>
        <div class="d-flex gap-1 align-items-center">
          <div><b>作業日時</b></div>
          <div>{{ startEndTimeSchedule }}</div>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col cols="5">
        <div class="d-flex align-items-baseline">
          <div class="me-3"><b>作業指示名</b></div>
          <router-link
            v-if="caseId"
            :to="{ name: 'projects.sales.instructions.detail', params: { id: caseId, work_order_id: workOrderId  }, query: { readonly: true, daily_report_id: dailyReport.id } }"
          >
            {{ dailyReport.work_order_json.name }}
          </router-link>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col cols="5">
        <div class="d-flex gap-1">
          <div class="badge-custom label-area blue"><b>排出事業者</b></div>
          <div class="content-area">{{ caseDischarger }}</div>
        </div>
      </b-col>
      <b-col>
        <div class="d-flex gap-1 align-items-center">
          <div class="label-area blue">排出事業者住所</div>
          <div class="content-area" v-if="caseDischargerAddress">{{ caseDischargerAddress }}</div>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col cols="5">
        <div class="d-flex gap-1">
          <div class="badge-custom label-area blue"><b>排出事業場</b></div>
          <div class="content-area">{{ caseDischargerSite }}</div>
        </div>
      </b-col>
      <b-col>
        <div class="d-flex gap-1 align-items-center">
          <div class="label-area blue">排出事業場住所</div>
          <div class="content-area" v-if="caseDischargerSiteAddress">{{ caseDischargerSiteAddress }}</div>
        </div>
      </b-col>
    </b-row>
    <template v-if="!vendorSite && needDisplayVendorInfo">
      <b-row class="mt-2">
      <b-col cols="5">
        <div class="d-flex gap-1">
          <div class="badge-custom label-area green"><b>処分事業者</b></div>
          <VendorsName
            v-if="dailyReport.schedule && dailyReport.schedule.waste_or_services_by_schedule"
            :wastes-or-service-by-schedule="dailyReport.schedule.waste_or_services_by_schedule"
          />
        </div>
      </b-col>
      <b-col>
        <div class="d-flex gap-1 align-items-center">
          <div class="label-area green">処分事業者住所</div>
          <VendorsAddress
            v-if="dailyReport.schedule && dailyReport.schedule.waste_or_services_by_schedule"
            :wastes-or-service-by-schedule="dailyReport.schedule.waste_or_services_by_schedule"
          />
        </div>
      </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="5">
          <div class="d-flex gap-1">
            <div class="badge-custom label-area green"><b>処分事業場</b></div>
            <VendorSitesName
              v-if="dailyReport.schedule && dailyReport.schedule.waste_or_services_by_schedule"
              :wastes-or-service-by-schedule="dailyReport.schedule.waste_or_services_by_schedule"
            />
          </div>
        </b-col>
        <b-col>
          <div class="d-flex gap-1">
            <div class="label-area green">処分事業場住所</div>
            <VendorSitesAddress
              v-if="dailyReport.schedule && dailyReport.schedule.waste_or_services_by_schedule"
              :wastes-or-service-by-schedule="dailyReport.schedule.waste_or_services_by_schedule"
            />
          </div>
        </b-col>
      </b-row>
    </template>
    <b-row class="mt-2">
      <b-col cols="5">
        <div class="d-flex gap-1">
          <div class="badge-custom label-area yellow"><b>最終更新者</b></div>
          <div v-if="updatedOrCreatedBy" v-html="updatedOrCreatedBy" class="content-area"></div>
        </div>
      </b-col>
      <b-col>
        <div class="d-flex gap-1">
          <div class="label-area yellow">業務担当者氏名</div>
          <div v-if="assignedStaffs" v-html="assignedStaffs" class="content-area"></div>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<style scoped lang="scss">
.label-area {
  padding: 10px;
  white-space:nowrap;
  font-weight: bold;
}
.blue {
  background: #92c4e7;
}
.green {
  background: #a6ddcb;
}
.yellow {
  background: #edf8b9;
}
.content-area {
  padding: 10px;
  background: #f8f9fa;
  width: 100%;
}
</style>
